import { useState } from 'react';
import { theme } from '../theme';
import { switchPinFare } from '../api/atlast';

// Confirmation for "Track this fare instead" (Oct 2026). Plain about the two
// things that matter: it is one switch, and it is not a Price Watch.
export default function SwitchFareModal({ pin, alt, onClose, onDone, formatMoney, currency }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  if (!pin || !alt) return null;
  const label = alt.kind === 'direct' ? 'the nonstop fare' : 'the best-value fare';

  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      await switchPinFare(pin.id);
      onDone && onDone();
    } catch (e) {
      const d = e?.response?.data?.detail;
      setError(typeof d === 'string' ? d : "Couldn't switch right now. Please try again.");
      setBusy(false);
    }
  };

  return (
    <div onClick={busy ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: theme.surface, border: `2px solid ${theme.border}`, borderRadius: '0px', padding: '26px 22px', maxWidth: '380px', width: '100%' }}>
        <div style={{ fontFamily: theme.fontDisplay, fontWeight: 700, fontSize: '17px', color: theme.textPrimary, marginBottom: '10px', textAlign: 'center' }}>
          Track this fare instead?
        </div>
        <div style={{ fontSize: '13.5px', color: theme.textMuted, lineHeight: 1.55, marginBottom: '8px', textAlign: 'center' }}>
          This trip will track {label}, currently {formatMoney(alt.price)} {currency}. We'll run one fresh check right away.
        </div>
        <div style={{ fontSize: '13px', color: theme.textMuted, lineHeight: 1.55, marginBottom: '18px', textAlign: 'center' }}>
          You can do this once per trip, so it can't be switched back. It doesn't start a Price Watch.
        </div>
        {error && <div role="alert" style={{ fontSize: '13px', color: '#B3261E', marginBottom: '12px', textAlign: 'center' }}>{error}</div>}
        <button onClick={go} disabled={busy} style={{ width: '100%', padding: '12px', background: theme.action, color: theme.structural, border: `2px solid ${theme.structural}`, borderRadius: '0px', fontWeight: 800, fontSize: '14px', cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.7 : 1, marginBottom: '8px' }}>
          {busy ? 'Switching…' : 'Yes, switch'}
        </button>
        <button onClick={onClose} disabled={busy} style={{ width: '100%', padding: '10px', background: 'transparent', color: theme.textMuted, border: 'none', fontSize: '13px', cursor: 'pointer' }}>
          Keep current fare
        </button>
      </div>
    </div>
  );
}
